// State, Region, Community selector
import StateRegionCommunitySelect from './lib/forms/community-select/state-region-community-select';

/**
 * This class is used with blog listing page
 */

class BlogListing {

    /**
     * 
     * @param {*} endPoint endpoint to hit to fetch results
     * @param {*} moduleElem jQuery element pointing to the the module containing the card listing
     * @param {*} pageSize 
     * @param {*} activeCategoryName Name of the active category filter
     */
    constructor(endPoint, moduleElem, pageSize, activeCategoryName = null) {
        this.endPoint = endPoint;
        this.moduleElem = $(moduleElem);
        this.filterElem = $(".filter-container");
        this.cardListingContainerElem = this.moduleElem.find(".card-listing")
        this.viewMoreButtonElem = this.cardListingContainerElem.closest(".cell").find("#view_more_btn");
        this.sortDropdownElem = this.filterElem.find("#sorts-dropdown");
        this.applyFilterButtonElem = this.filterElem.find(".blog-filter-button");
        this.clearFilterButtonElem = this.filterElem.find(".button-clear-filters");
        // filter dropdowns
        this.statesDropdown = this.filterElem.find("#states-dropdown");
        this.regionsDropdown = this.filterElem.find("#regions-dropdown");
        this.communitiesDropdown = this.filterElem.find("#communities-dropdown");
        // active category
        this.activeCategoryName = activeCategoryName;
        this.pageCounter = 1;
        this.pageSize = pageSize;
        this.isApplyFilterClicked = false;
    }

     /**
     * Initialize init function of js class 
     */
    init() {
        let clsInstance = this;

        this.viewMoreButtonElem.on("click", (event) => this.onViewMoreButtonClick(event));
        this.applyFilterButtonElem.on("click",(event) => this.onApplyFilterButtonClick(event));
        this.sortDropdownElem.on("change", (event) => this.onApplyFilterButtonClick(event));
        this.clearFilterButtonElem.on("click", (event) => this.onClearFilterButtonClick(event));
    }
    
     /**
     * Initialize filter and dropdowns values 
     * @param config contains all the dropdown id's and json values for all the dropdown which is set on page from where it's called
     * @see constructor comment within state-region-community-select.js for information regarding structure of the config parameter
     */
    initDropdownFilters(config) {
        this.config = config;
        // initialize the dropdown filters with the json data provided by backend
         // Set the data used to populate the dropdowns
         this.stateRegionCommunitySelect = new StateRegionCommunitySelect(
            config.states,
            config.marketAreasByState,
            config.communitiesByRegion,
            this.filterElem,
            false
        );

        // Attach the data to the dropdowns
        this.stateRegionCommunitySelect.attachData(
            this.statesDropdown,
            this.regionsDropdown,
            this.communitiesDropdown,
            this.pillboxContainer
        );

        // Style the single select dropdowns in this form
        let singleSelectDropDowns = this.filterElem.find('.shea-custom-dropdown-singleselect');
        singleSelectDropDowns.each(function () {
            window.initCustomDropdowns(this, false);
        });

        //Set filters default value on page revisit
        
            //open filters area to see the selected options
            $(".filter-btn").trigger('click');
            //Set state from selected value of previous visit
            if(config!=null && config.selectedState!=null && config.selectedState!="")
            {
                $(this.statesDropdown).val(config.selectedState).trigger('change');
                var itemToSelect = config.states.find(x => x.StateCode == config.selectedState);
                if (itemToSelect) {
                    var lblState = this.statesDropdown.parent().find('.dropdown-label');
                    if (lblState != undefined && lblState != null) {
                        $(lblState).html(itemToSelect.Name);
                    }
                }
            }
            //Set region from selected value of previous visit 
            if(config!=null && config.selectedRegion!=null && config.selectedRegion!="")
            {
                $(this.regionsDropdown).val(config.selectedRegion).trigger('change');
                var lblRegion = this.regionsDropdown.parent().find('.dropdown-label');
                if(lblRegion !=undefined && lblRegion!=null)
                {
                    $(lblRegion).html(itemToSelect);
                }                
            }
            //Set communities from selected value of previous visit
            if(config!=null && config.selectedCommunity!=null && config.selectedCommunity!="" && config.selectedRegion!=null && config.selectedRegion!="" && config.selectedRegion!="All Regions")
            {
                $(this.communitiesDropdown).val(config.selectedCommunity).trigger('change');
                var itemToSelect = config.communitiesByRegion[config.selectedRegion].find(x => x.NodeGuid == config.selectedCommunity);
                if (itemToSelect) { 
                    var lblCommunity = this.communitiesDropdown.parent().find('.dropdown-label');
                    if(lblCommunity !=undefined && lblCommunity!=null)
                    {
                        $(lblCommunity).html(itemToSelect.Name);
                    }
                }
            }
            //Set sorting order from selected value of previous visit
            if(config!=null && config.selectedSortMode!=null && config.selectedSortMode!='')
            {
                this.sortDropdownElem.val(config.selectedSortMode).trigger('change');
                var ddlSortId = this.sortDropdownElem.attr('id');
                var itemToSelect = config.selectedSortMode.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
                $('#select2-'+ ddlSortId +'-container').find('span.dropdown-label').html(itemToSelect);
            }
      
    }

     /**
     * Event Handler for click of view more button
     * @param {jQuery Event} e event object
     */
     onViewMoreButtonClick(e) {
        e.preventDefault();
        this.fetchBlogPosts().then((response) => {
            window.hidePreLoader();
        }).catch((error) => {
            console.error(error);
        }).finally(() => {
            window.hidePreLoader();
        });
    }

    
     /**
     * Event Handler for click of apply filter button
     * @param {jQuery Event} e event object
     */
     onApplyFilterButtonClick(e) {
        this.pageSize = 0;
        this.isApplyFilterClicked = true;
        e.preventDefault();
        this.fetchBlogPosts().then((response) => {
            window.hidePreLoader();
        }).catch((error) => {
            console.error(error);
        }).finally(() => {
            window.hidePreLoader();
        });
    }

    
     /**
     * Event Handler for click of clear filter button
     * @param {jQuery Event} e event object
     */
     onClearFilterButtonClick(e) {
        
        window.hidePreLoader();

        this.pageSize = 0;
        //Clear drop-down selected value on clear button click 
        $(this.statesDropdown).val('').trigger('change');
        $(this.statesDropdown).removeClass("is-invalid-input");
        
        $(this.regionsDropdown).val('').trigger('change');
        $(this.regionsDropdown).attr("disabled","");

        $(this.communitiesDropdown).val('').trigger('change');
        $(this.communitiesDropdown).attr("disabled","");

        this.isApplyFilterClicked = true;
    }

    
     /**
     * Fetch blog posts to get the list based on selected filter and sort mode
     */
    fetchBlogPosts() {
        let _this = this;
        return new Promise(function (resolve, reject) {
            try {
                //Get state drop-down data 
                let state = "";
                let regions = "";
                let communities = "";

                // If filter markup is defined 
                if (_this.filterElem != null && _this.filterElem.length > 0)
                {
                    //Get state drop-down data 
                    state = _this.statesDropdown != null ? (_this.statesDropdown.val() ?? "") : "";
                    regions = _this.regionsDropdown != null ? (_this.regionsDropdown.val() ?? "") : "";
                    communities = _this.communitiesDropdown != null ? (_this.communitiesDropdown.val() ?? "") : "";
                }

                let categoryName = _this.activeCategoryName;
                let sortMode = $(_this.sortDropdownElem).val();

                //set the filter parameters in the browser's history so that filter options
                //can be applied when the user hits the back button
                const url = new URL(window.location);
                url.searchParams.set("state", state);
                url.searchParams.set("region", regions);
                url.searchParams.set("community", communities);
                url.searchParams.set("sortMode", sortMode);
                url.searchParams.set("categoryName", categoryName);
                window.history.pushState({}, "", url);

                // Get Anti-CSRF token
                let csrfToken = _this.filterElem.find('[name="__RequestVerificationToken"]').val();
                let endpointUrl = _this.endPoint;
                let pageSize = _this.pageSize;
                let data = { 
                    state: state, 
                    region: regions,
                    community: communities,
                    categoryName: categoryName,
                    start: pageSize,
                    sortMode: sortMode 
                };
                
                $.ajax({
                    type: "GET",
                    url: endpointUrl,
                    data: data,
                    cache: false,
                    dataType: "html",
                    beforeSend: function (request) {
                        if (csrfToken) {
                            request.setRequestHeader("__RequestVerificationToken", csrfToken);
                        }
                        window.showPreLoader();
                    },
                    success: function (response) {
                        if ((response != null)) {
                            if (resolve) resolve(response);
                            var parsedResponse = JSON.parse(response);
                            var blogData = parsedResponse.BlogPostMarkup;

                            // Append the HTML code to a div element with the given ID
                            if(_this.isApplyFilterClicked){

                                _this.cardListingContainerElem.html("");
                                _this.cardListingContainerElem.append(blogData);
                            }
                            else{
                                _this.cardListingContainerElem.append(blogData);
                            }
                            
                            //Set view more button based on response
                            if(parsedResponse!=undefined && parsedResponse!=null && !parsedResponse.ShowViewMore){
                                _this.viewMoreButtonElem.hide();
                            }
                            else
                            {
                                _this.viewMoreButtonElem.show();
                            }

                            //Set page size based on response
                            if(parsedResponse!=null && parsedResponse.Start!=null && parsedResponse.Start!=undefined && parsedResponse.Start>0  )
                            {
                                _this.pageSize = parsedResponse.Start;
                            }

                            _this.isApplyFilterClicked =false;

                            //Display no blog message when no blog available
                            if(parsedResponse!=null && parsedResponse.NoBlogMessage!=null )
                            {
                                _this.cardListingContainerElem.append(parsedResponse.NoBlogMessage);
                            }

                            // lazy load images
                            lozadObserver();

                            // Recalculate equalizer
                            window.Foundation.reInit('equalizer');
                            
                        }
                        else {
                            if (reject) reject(response);
                        }
                    },
                    error: function (request, textStatus, errorThrown) {
                        if (reject) reject("AJAX error: " + request.statusText);
                    }
                })
            }
            catch (err) {
                if (reject) reject("Error occurred fetching cards:" + err);
            }
        });

    }
}
window.BlogListing = BlogListing;